module.exports = __webpack_public_path__ + "img/bg-light.2ef16215.jpg";